import {verifySession} from '@/api';
import constants from '@/constants';

let lastCheck = null;

const exports = {
  beginStatusChecks
};

export default exports;

/////////

function beginStatusChecks() {
  clearTimeout(lastCheck);
  lastCheck = setTimeout(
    beginStatusChecks,
    constants.OFFLINE_STATUS_CHECK_FREQUENCY
  );
  return verifySession();
}
